(function () {
  function getSection() {
    return document.querySelector('[data-section-type="product"]');
  }

  function initStickyInfoRow() {
    var infoRow = document.querySelector('.ig-sticky-info-row');
    if (!infoRow) return;
    infoRow.setAttribute('aria-hidden', 'false');

    var priceEl = document.querySelector('[data-ig-sticky-price]');
    var compareEl = document.querySelector('[data-ig-sticky-compare]');
    var msiEl = document.querySelector('[data-ig-sticky-msi]');
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;

      if (priceEl) {
        priceEl.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!compareEl && priceEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'ig-sticky-info-row__compare';
          compareEl.setAttribute('data-ig-sticky-compare', '');
          priceEl.insertAdjacentElement('afterend', compareEl);
        }
        if (compareEl) {
          compareEl.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
          compareEl.style.display = '';
        }
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }

      if (msiEl) {
        var msiAmount = Math.round(variant.price / 6);
        msiEl.innerHTML = 'o 6 MSI de ' + theme.Currency.formatMoney(msiAmount, theme.settings.moneyFormat);
      }

    });
  }

  function initIntelligemsSticky() {
    if (document.body.classList.contains('ig-sticky-v2')) {
      initStickyInfoRow();
      return;
    }

    var startObserver = function () {
      if (document.body.classList.contains('ig-sticky-v2')) {
        initStickyInfoRow();
        return;
      }
      var obs = new MutationObserver(function () {
        if (document.body.classList.contains('ig-sticky-v2')) {
          obs.disconnect();
          initStickyInfoRow();
        }
      });
      obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }
  }

  function initPreorderAndKueski() {
    var section = getSection();
    if (!section) return;

    var preorderEl = document.querySelector('#pre-order #text_date_preorder');
    if (preorderEl) {
      // Fuente principal: metafield custom.fecha_pre_order (expuesto vía data-preorder-date).
      var fecha = (section.getAttribute('data-preorder-date') || '').trim();
      // Fallback al sistema viejo (preorder-dates.js) durante la migración.
      if (!fecha) {
        var skusAttr = section.getAttribute('data-product-skus');
        var skus = skusAttr ? skusAttr.split(',') : [];
        var skuFechas = typeof getPreorderDates === 'function' ? getPreorderDates() : {};
        for (var i = 0; i < skus.length; i++) {
          if (skuFechas[skus[i]]) {
            fecha = skuFechas[skus[i]];
            break;
          }
        }
      }
      if (fecha) {
        var prefijo = (window.theme && theme.strings && theme.strings.preorderEstimatedDelivery) || 'Fecha estimada de entrega: ';
        preorderEl.innerHTML = prefijo + fecha;
      }
    }

    var priceCents = parseInt(section.getAttribute('data-product-price'), 10) || 0;

    function updateKueskiAccordion(cents) {
      var precioKueski = '$' + (cents / 100 / 4).toFixed(2);
      document.querySelectorAll('.kueski-price-value').forEach(function (el) {
        el.textContent = precioKueski;
      });
      var accordionPrice = document.getElementById('kueski-accordion-price');
      if (accordionPrice) accordionPrice.textContent = precioKueski;
    }

    updateKueskiAccordion(priceCents);

    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      updateKueskiAccordion(variant.price);
    });
  }

  window.toggleAccordion = function (item) {
    var isActive = item.classList.contains('active');
    document.querySelectorAll('.accordion-item').forEach(function (el) {
      el.classList.remove('active');
    });
    if (!isActive) item.classList.add('active');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreorderAndKueski);
  } else {
    initPreorderAndKueski();
  }

  initIntelligemsSticky();
})();
